import api from "./api";

export async function getIndicators (
    status = '',
    currentPage = 1,
    q='',
    onlyTrashed = false,
    language,
    filter_tag = '',
    filter_tag_name = '',
    withTrashed=false
) {
    return api.get(`/indicators?q=${q}&status=${status}&paginate=true&page=${currentPage}&onlyTrashed=${onlyTrashed}&filter_tag=${filter_tag}&filter_tag_name=${filter_tag_name}&withTrashed=${withTrashed}&language=${language}`
    )
        .then(response => response.data)
        .catch(error => console.log(error));
}

export async function getIndicatorsDashboard(
    q='',
    status = '',
    currentPage = 1,
    language,
    year_reference
){

    return api.get(`/indicators?q=${q}&status=${status}&paginate=true&page=${currentPage}&language=${language}&year_reference=${year_reference}&minified=true`)
        .then(response => response.data)
        .catch(error => console.log(error));

}

export async function getIndicatorsList(props) {

    const { status = '',
        currentPage = 1,
        q = '',
        onlyTrashed = false,
        language,
        filter_tag = '',
        filter_tag_name = '',
        withTrashed = false,
        minified = false,
        sortDirection = 'asc',
        sortBy = 'titulo',
        year_reference
    } = props

    return api.get(`/indicators?q=${q}&status=${status}&paginate=true&page=${currentPage}&onlyTrashed=${onlyTrashed}&filter_tag=${filter_tag}&filter_tag_name=${filter_tag_name}&withTrashed=${withTrashed}&language=${language}&minified=${minified}&sortDirection=${sortDirection}&sortBy=${sortBy}&year_reference=${year_reference}`
    )
        .then(response => response.data)
        .catch(error => console.log(error));
}

export async function getIndicatorsWithoutPage () {
    return api.get(`/indicators`)
        .then(response => response.data)
        .catch(error => console.log('error without page', error));
}

export async function getIndicatorsByUser(
    user_id = '',
    status = '',
    paginate= true,
    profile = '',
    language = 'pt-BR',
    currentPage,
){

   // return api.get(`/indicators/byuser/${user_id}?q=${q}&status=${status}&paginate=true&page=${currentPage}&onlyTrashed=${onlyTrashed}&language=${language}&widget=${widget}${filterProfile}`)
    return api.get(`/indicators/byuser/${user_id}?status=${status}&type=${profile}&language=${language}&paginate=${paginate}&page=${currentPage}`)
        .then(response => response.data)
        .catch(error => console.log('error by user', error));
}

export async function getIndicatorsListByUser(props){
    const {
        q = '',
        user_id = '',
        status = '',
        paginate= true,
        profile = '',
        language = 'pt-BR',
        currentPage,
        minified = false,
        sortDirection = 'asc',
        sortBy = 'titulo',
        year_reference
    } = props
    return api.get(`/indicators/byuser/${user_id}?q=${q}&status=${status}&type=${profile}&language=${language}&paginate=${paginate}&page=${currentPage}&minified=${minified}&sortDirection=${sortDirection}&sortBy=${sortBy}`)
        .then(response => response.data)
        .catch(error => console.log('error by user', error));
}

export async function getIndicator(id, status = '') {

    if(!id) return

    return api.get(`/indicators/${id}?status=${status}`)
        .then((response) => response.data.data)
        .catch(error => {
           // toast.error(i18n.t('error.notFoundIndicator'));
            console.log('error get indicator id')
        })
}

export async function getIndicatorId (
    q='',
    status = '',
    type = '',
    limit = '',
    paginate = false,
    page = 1,
    id= '',
)
{
    return api.get(`/indicators/${id}?q=${q}&status=${status}&with=${type}&limit=${limit}&paginate=${paginate}&page=${page}`)
        .then(response => response.data.data)
        .catch(error => console.log(error));
}

export function newIndicator(data) {
    return api.post(`/indicators`, data);
}

export function setIndicators (id, data) {
    return api.put(`/indicators/${id}`, data);
}

export function setData (table_id, data) {
    return api.put(`/tables/${table_id}`, data);
}

export function setNewData (data) {
    return api.post(`/tables`, data);
}

export function deleteData (id) {
    return api.delete(`/tables/${id}`)
        .then(response => response.data)
        .catch(error => {
            return error.response
        });
}


export function setIndicator (id, data) {
    return api.put(`/indicators/${id}`, data)
        .then(response => response.data)
        .catch(error => {
            return error.response
        });
}

export function dellIndicators (id, forceDelete = false) {
    return api.delete(`/indicators/${id}?forceDelete=${forceDelete}`)
        .then(response => response.data)
        .catch(error => console.log(error));
}

export function restoreIndicators (id) {
    return api.post(`/indicators/${id}/restore`)
        .then(response => response.data)
        .catch(error => console.log(error));
}

export function addIndicatorUser(data) {
    return api.post(`/indicatorUsers`, data)
        .then(response => response.data)
        .catch(error => console.log(error));
}

export function updateIndicatorUser(data) {
    return api.put('/indicatorUsers', data)
        .then(response => response.data)
        .catch(error => console.log(error));
}

export function getIndicatorUser(id) {
    return api.get(`/indicatorUsers?indicator=${id}`)
        .then(response => response.data)
        .catch(error => console.log(error));
}

export function getIndicatorsOverdue(type) {
    return api.post(`/indicatorUsers/overdue`, {'type': type})
        .then(response => response.data)
        .catch(error => console.log(error));
}

export function deleteIndicatorUser(id) {
    return api.delete(`/indicatorUsers/${id}`)
        .then(response => response.data)
        .catch(error => console.log(error));
}

export async function getIndicatorByCode(code, language = '') {
    return api.get(`/indicators/bycode/${code}?language=${language}`)
        .then(response => response.data)
        .catch(error => console.log(error));
}

export async function getIndicatorById(id, minified = false) {
    return api.get(`/indicators/byid/${id}?indicatorId=${id}&minified=${minified}`)
        .then(response => {
            if(response.data) {
                return response.data.data[0]
            }
        })
        .catch(error => console.log(error));
}

export function getIndicatorInformation(props) {

    const {
        indicator_id,
        reference
    } = props


    return api.get(`/indicatorsInformation?indicator_id=${indicator_id}&reference=${reference}`)
        .then(response => response.data)
        .catch(error => console.log(error));
}


export function createIndicatorInformation(data) {
    return api.post(`/indicatorsInformation`, data)
        .then(response => response.data)
        .catch(error => console.log(error));
}

export function updateIndicatorInformation(data) {
    return api.put(`/indicatorsInformation/${data.id}`, data)
        .then(response => response.data)
        .catch(error => console.log(error));
}

export function duplicateIndicator(indicatorId) {
    return api.post('/indicators/duplicate', {'indicator_id': indicatorId})
        .then(response => response.data)
        .catch(error => console.log(error));
}

